<template>
    <div>
        <div class="row">
            <h1 class="page-title page-title--category">Agencies</h1>
            <h4 class="page-title--total" v-if="!loading">
                {{ items.length }} of {{ total_items }} total
            </h4>
        </div>

        <div class="row referral-invoices-filter filter agencies--filter">
            <form method="get">
                <div class="row" style="width: 100%;">
                    <div class="col-xl-4 col-lg-4">
                        <div class="form-field form-field__select">
                            <label for="agency">Search</label>
                            <input
                                type="text"
                                v-debounce:500ms="search"
                                id="agency"
                                v-model="searchRequest"
                            />
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4">
                        <div class="row">
                            <div class="col-xl-9 col-lg-9">
                                <div class="form-field form-field--tree">
                                    <label for="service">Service</label>
                                    <treeselect
                                        id="service"
                                        @input="onChangeFilterItem"
                                        @deselect="onChangeFilterItem"
                                        @select="onChangeFilterItem"
                                        v-model="filters.service"
                                        :multiple="true"
                                        :valueConsistsOf="'BRANCH_PRIORITY'"
                                        :options="options.service"
                                        :clearOnSelect="true"
                                    />
                                </div>
                            </div>
                            <div
                                class="col-xl-3 col-lg-3"
                                style="padding-top: 24px"
                            >
                                <div
                                    class="form-field form-field--radiobutton"
                                    style="margin-bottom: 8px; padding-right: 0"
                                >
                                    <input
                                        type="radio"
                                        :id="`services_is_all`"
                                        :checked="filters.services_is_all"
                                        name="services_is_all"
                                        class="type-create-deals js-edit-commission-type"
                                        value="all"
                                        @change="onChangeServiceIsAll"
                                    />
                                    <label :for="`services_is_all`">All</label>
                                </div>
                                <div
                                    class="form-field form-field--radiobutton"
                                    style="padding-right: 0"
                                >
                                    <input
                                        type="radio"
                                        :id="`services_is_any`"
                                        :checked="!filters.services_is_all"
                                        name="services_is_all"
                                        class="type-create-deals js-edit-commission-type"
                                        value="any"
                                        @change="onChangeServiceIsAll"
                                    />
                                    <label :for="`services_is_any`">Any</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4">
                        <div class="row">
                            <div class="col-xl-9 col-lg-9">
                                <div class="form-field form-field--tree">
                                    <label for="industry">Industry</label>
                                    <treeselect
                                        id="industry"
                                        @input="onChangeFilterItem"
                                        @deselect="onChangeFilterItem"
                                        @select="onChangeFilterItem"
                                        v-model="filters.industry"
                                        :multiple="true"
                                        :valueConsistsOf="'ALL'"
                                        :options="options.industry"
                                        :clearOnSelect="true"
                                    />
                                </div>
                            </div>
                            <div
                                class="col-xl-3 col-lg-3"
                                style="padding-top: 24px"
                            >
                                <div
                                    class="form-field form-field--radiobutton"
                                    style="margin-bottom: 8px; padding-right: 0"
                                >
                                    <input
                                        type="radio"
                                        :id="`industries_is_all`"
                                        :checked="filters.industries_is_all"
                                        name="industries_is_all"
                                        class="type-create-deals js-edit-commission-type"
                                        value="all"
                                        @change="onChangeIndustryIsAll"
                                    />
                                    <label :for="`industries_is_all`"
                                        >All</label
                                    >
                                </div>
                                <div
                                    class="form-field form-field--radiobutton"
                                    style="padding-right: 0"
                                >
                                    <input
                                        type="radio"
                                        :id="`industries_is_any`"
                                        :checked="!filters.industries_is_all"
                                        name="industries_is_all"
                                        class="type-create-deals js-edit-commission-type"
                                        value="any"
                                        @change="onChangeIndustryIsAll"
                                    />
                                    <label :for="`industries_is_any`"
                                        >Any</label
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="form-field form-field--button form-field--button-new">
                <a href="/agencies/create" class="btn btn--gray">
                    <i class="icon icon-plus"></i>Add agency</a
                >
                <button
                    @click="openColumnsModal"
                    type="button"
                    class="btn btn--gray"
                >
                    Edit column view
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-3">
                <div class="flex flex-wrap filter-btn-wrap">
                    <button
                        @click="toggleSidebar"
                        class="btn btn--gray btn-toggle-filter"
                    >
                        <i class="icon icon-filter"></i> Toggle filter
                    </button>
                    <button
                        @click="clearFilter"
                        class="btn btn--gray btn-clear-filter"
                    >
                        <i class="icon icon-clear-filter"></i>
                    </button>
                </div>
            </div>
            <div class="col-xl-9 col-lg-9 col-md-9">
                <div class="checkbox flex flex-wrap">
                    <div
                        class="form-field flex checkbox-wrap"
                        style="
                            width: auto;
                            margin-right: 24px;
                            align-items: center;
                        "
                    >
                        <input
                            type="checkbox"
                            :id="`filter_status_all`"
                            @change="onChangeStatusAll"
                            :ref="`filter_all`"
                            :checked="filters.agencies_status.length <= 0"
                        />
                        <label :for="`filter_status_all`"
                            ><i class="icon icon-checkmark"></i
                        ></label>
                        All
                    </div>
                    <div
                        class="form-field flex checkbox-wrap"
                        v-for="s in options.status"
                        :key="s.id"
                        style="
                            width: auto;
                            margin-right: 24px;
                            align-items: center;
                        "
                    >
                        <input
                            type="checkbox"
                            :id="`filter_status_${s.id}`"
                            :value="s.id"
                            @change="onChangeStatusCheckbox"
                            name="status[]"
                            :ref="`filter_status_${s.id}`"
                        />
                        <label :for="`filter_status_${s.id}`"
                            ><i class="icon icon-checkmark"></i
                        ></label>
                        {{ s.label }}
                    </div>
                    {{ filters.status }}
                </div>
            </div>
        </div>

        <!-- <div
            class="row master-invoices-pagination master-invoices-pagination--top"
        ></div> -->

        <div
            class="row agencies-table table-data-row"
            :class="is_open_sidebar ? 'table-data-row--open-sidebar' : ''"
        >
            <div class="sidebar-filter">
                <div class="sidebar-filter__header" ref="filters_head">
                    Filters
                </div>
                <div class="sidebar-filter__body">
                    <div class="form-field sidebar-filter__field">
                        <label for="name_quickbooks">Name in Quickbooks</label>
                        <input
                            type="text"
                            v-model="filters.name_in_quickbooks"
                            v-debounce:500ms="fetchData"
                            id="name_quickbooks"
                        />
                    </div>
                    <div
                        class="form-field sidebar-filter__field form-field--tree"
                    >
                        <label for="client_size">Client size</label>
                        <treeselect
                            id="client_size"
                            v-model="filters.client_size"
                            @input="onChangeFilterItem"
                            :multiple="false"
                            :options="options.client_size"
                            :clearOnSelect="true"
                        />
                    </div>
                    <div
                        class="form-field sidebar-filter__field form-field--tree"
                    >
                        <label for="international">International</label>
                        <treeselect
                            id="international"
                            v-model="filters.international"
                            @input="onChangeFilterItem"
                            :multiple="false"
                            :options="options.international"
                            :clearOnSelect="true"
                        />
                    </div>
                    <div
                        class="form-field sidebar-filter__field form-field--tree"
                    >
                        <label for="type">Type</label>
                        <treeselect
                            id="type"
                            v-model="filters.type"
                            @input="onChangeFilterItem"
                            :multiple="false"
                            :options="options.type"
                            :clearOnSelect="true"
                        />
                    </div>
                    <div
                        class="form-field sidebar-filter__field form-field--tree"
                    >
                        <label for="language">Language</label>
                        <treeselect
                            id="language"
                            v-model="filters.language"
                            @input="onChangeFilterItem"
                            :multiple="false"
                            :options="options.language"
                            :clearOnSelect="true"
                        />
                    </div>
                    <div
                        class="form-field sidebar-filter__field form-field--tree"
                    >
                        <label for="niche">Niche</label>
                        <treeselect
                            id="niche"
                            v-model="filters.niche"
                            @input="onChangeFilterItem"
                            :multiple="false"
                            :options="options.niche"
                            :clearOnSelect="true"
                        />
                    </div>
                    <div
                        class="form-field sidebar-filter__field form-field--tree"
                    >
                        <label for="skill">Skill</label>
                        <treeselect
                            id="skill"
                            v-model="filters.skill"
                            @input="onChangeFilterItem"
                            :multiple="false"
                            :options="options.skill"
                            :clearOnSelect="true"
                        />
                    </div>
                    <div
                        class="form-field sidebar-filter__field form-field--tree"
                    >
                        <label for="source">Source</label>
                        <treeselect
                            id="source"
                            v-model="filters.source"
                            @input="onChangeFilterItem"
                            :multiple="false"
                            :options="options.source"
                            :clearOnSelect="true"
                        />
                    </div>
                    <!-- <div
                        class="form-field sidebar-filter__field form-field--tree"
                    >
                        <label for="status">Status</label>
                        <treeselect
                            id="status"
                            v-model="filters.status"
                            @input="onChangeFilterItem"
                            :multiple="false"
                            :options="options.status"
                            :clearOnSelect="true"
                        />
                    </div> -->
                    <div class="group-row">
                        <div
                            class="group-row__label"
                            style="background: #f4f4f4"
                        >
                            Budget
                        </div>
                        <div
                            class="form-field form-field--radiobutton"
                            style="margin-bottom: 8px"
                        >
                            <input
                                type="radio"
                                :id="`budget_type_monthly`"
                                :checked="filters.budget_type == 'monthly'"
                                name="budget_type_id"
                                class="type-create-deals js-edit-commission-type"
                                value="monthly"
                                @change="onChangeBudgetType"
                            />
                            <label :for="`budget_type_monthly`"
                                >Monthly retainer fee</label
                            >
                        </div>
                        <div
                            class="form-field form-field--radiobutton"
                            style="margin-bottom: 8px"
                        >
                            <input
                                type="radio"
                                :id="`budget_type_project`"
                                :checked="filters.budget_type == 'project'"
                                name="budget_type_id"
                                class="type-create-deals js-edit-commission-type"
                                value="project"
                                @change="onChangeBudgetType"
                            />
                            <label :for="`budget_type_project`"
                                >Project budget</label
                            >
                        </div>
                        <div class="form-field sidebar-filter__field">
                            <input
                                v-debounce:500ms="fetchData"
                                type="text"
                                v-model="filters.min_budget"
                                id="min_budget"
                            />
                        </div>
                    </div>
                    <div class="form-field sidebar-filter__field">
                        <label for="city">City</label>
                        <input
                            type="text"
                            v-model="filters.city"
                            v-debounce:500ms="fetchData"
                            id="city"
                        />
                    </div>

                    <div
                        class="form-field sidebar-filter__field form-field--tree"
                    >
                        <label for="source">State</label>
                        <treeselect
                            id="source"
                            v-model="filters.state"
                            @input="onChangeFilterItem"
                            :multiple="false"
                            :options="options.state"
                            :clearOnSelect="true"
                        />
                    </div>
                    <div
                        class="form-field sidebar-filter__field checkbox-wrap"
                        style="margin-bottom: 0"
                    >
                        <input
                            v-model="filters.enable_distance"
                            type="checkbox"
                            id="enable_distance"
                        />
                        <label for="enable_distance">
                            <i class="icon icon-checkmark"></i>
                        </label>
                        Distance, mi
                    </div>
                    <div class="form-field sidebar-filter__field">
                        <input
                            :disabled="!filters.enable_distance"
                            type="text"
                            @input="handleEnterDistance"
                            id="distance"
                        />
                    </div>
                </div>
            </div>
            <div class="table-wrap">
                <table class="table">
                    <thead ref="thead">
                        <tr
                            v-if="current_columns && current_columns.length > 0"
                        >
                            <th
                                v-for="col_obj in current_columns
                                    .filter((c) => c.status === 'show')
                                    .sort((a, b) => a.position - b.position)"
                                v-bind:key="'col_table_th_' + col_obj.id"
                                @click="sortData(col_obj.slug)"
                            >
                                <span
                                    v-if="lastSort == col_obj.slug"
                                    :class="
                                        descending &&
                                        lastSort == col_obj.slug &&
                                        'sort-icon--desc'
                                    "
                                    ><i class="icon icon-down-arrow"></i
                                ></span>
                                {{ col_obj.name }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loading">
                            <td colspan="16">
                                <clip-loader
                                    :loading="loading"
                                    :color="'#ec4657'"
                                    :size="'45px'"
                                ></clip-loader>
                            </td>
                        </tr>
                        <tr v-else-if="!items.length && !loading">
                            <td colspan="16"><center>No data</center></td>
                        </tr>
                        <!-- <tr
                            v-else-if="
                                searchRequest.length >= 3 && filterItems.length
                            "
                            v-for="item in filterItems"
                            :key="item.id"
                        >
                            <td
                                v-for="_col in current_columns.filter(
                                    (c) => c.status === 'show'
                                )"
                                v-bind:key="'col_table_agency_' + _col.id"
                            >
                                <a
                                    v-if="_col.is_link && item[_col.slug].link"
                                    :href="item[_col.slug].link"
                                    :style="
                                        item.status == 'Overdue'
                                            ? 'color:red'
                                            : ''
                                    "
                                    >{{ item[_col.slug].name }}</a
                                >
                                <button
                                    v-else-if="_col.slug === 'action'"
                                    class="btn btn--icon"
                                    @click="deleteAgency(item.id)"
                                    type="button"
                                >
                                    <i class="icon icon-trash"></i>
                                </button>
                                <p
                                    v-else
                                    :class="
                                        !item[_col.slug] ||
                                        item[_col.slug] === '-' ||
                                        item[_col.slug] <= 0
                                            ? 'color-of-null'
                                            : ''
                                    "
                                >
                                    {{ item[_col.slug] || "-" }}
                                </p>
                            </td>
                        </tr> -->
                        <!-- <tr
                            v-else-if="
                                !filterItems.length && searchRequest.length >= 3
                            "
                        >
                            <td colspan="16"><center>No data</center></td>
                        </tr> -->
                        <tr v-else v-for="item in items" :key="item.id">
                            <!--                            <td>{{ item.id }}</td>-->
                            <td
                                v-for="_col in current_columns.filter(
                                    (c) => c.status === 'show'
                                )"
                                v-bind:key="'col_table_partner_' + _col.id"
                            >
                                <a
                                    v-if="
                                        _col.is_link &&
                                        item[_col.slug].link &&
                                        _col.slug === 'name'
                                    "
                                    :href="item[_col.slug].link"
                                    :style="
                                        item.status == 'Overdue'
                                            ? 'color:red'
                                            : ''
                                    "
                                    target="_blank"
                                    class="agency-icon-col"
                                >
                                    <img
                                        v-if="item[_col.slug].favicon"
                                        :src="item[_col.slug].favicon"
                                        class="agency-icon-image"
                                    />
                                    {{ item[_col.slug].name }}</a
                                >
                                <a
                                    v-else-if="
                                        _col.is_link && item[_col.slug].link
                                    "
                                    :href="item[_col.slug].link"
                                    :style="
                                        item.status == 'Overdue'
                                            ? 'color:red'
                                            : ''
                                    "
                                    >{{ item[_col.slug].name }}</a
                                >
                                <button
                                    v-else-if="_col.slug === 'action'"
                                    class="btn btn--icon"
                                    @click="handleDeleteAgency(item.id)"
                                    type="button"
                                >
                                    <i class="icon icon-trash"></i>
                                </button>
                                <p
                                    v-else
                                    :class="
                                        !item[_col.slug] ||
                                        item[_col.slug] === '-' ||
                                        item[_col.slug] <= 0
                                            ? 'color-of-null'
                                            : ''
                                    "
                                >
                                    {{ item[_col.slug] || "-" }}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row master-invoices-pagination jus-c--right"></div>

        <Column_Modal
            :is_show="showModalColumns"
            :__columns="current_columns"
            :selectColumn="selectColumn"
            :closeModal="closeModal"
            :selected_col="selected_col"
            v-if="showModalColumns"
        ></Column_Modal>

        <Confirm_Modal
            v-if="delete_id"
            :title="getAgencyName"
            :onApplyAction="() => deleteAgency(delete_id)"
            :onSecondaryAction="() => handleDeleteAgency(null)"
            :applyLabel="'Delete'"
            :secondaryLabel="'Cancel'"
        />
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import axios from "axios";

import Column_Modal from "../ColumnModal/index.vue";
import Confirm_Modal from "../ConfirmModal/index.vue";
import {
    sortDate,
    sortMoney,
    sortNumber,
    sortText,
} from "../../parts/sort-array";
import debounce from "lodash/debounce";

export default {
    name: "Agencies",
    props: [
        "total_items",
        "gates",
        "columns",
        "industries",
        "services",
        "clientSizes",
        "languages",
        "niches",
        "skills",
        "sources",
        "states",
        "agency_statuses",
        "types",
        "states",
    ],
    components: {
        ClipLoader,
        Column_Modal,
        Treeselect,
        Confirm_Modal,
    },
    data() {
        return {
            selectedStatus: [],
            loading: false,
            items: [],
            filterItems: [],
            searchRequest: "",
            //selectedAgency: { id: 0, name: "All" },
            descending: false,
            lastSort: "active_deals",
            showModalColumns: false,
            selected_col: null,
            current_columns: [],
            filter_columns: [],
            is_open_sidebar: false,
            filters: {
                industry: null,
                service: null,
                name_in_quickbooks: "",
                client_size: null,
                international: null,
                type: null,
                language: null,
                niche: null,
                skill: null,
                source: null,
                min_budget: "",
                status: null,
                city: "",
                state: null,
                distance: null,
                enable_distance: false,
                agencies_status: [],
                budget_type: "monthly",
                services_is_all: true,
                industries_is_all: true,
                state: null,
            },
            options: {
                industry: this.industries,
                service: this.services,
                client_size: this.clientSizes,
                international: [
                    {
                        id: true,
                        label: "Yes",
                    },
                    {
                        id: false,
                        label: "No",
                    },
                ],
                type: this.types,
                language: this.languages,
                niche: this.niches,
                skill: this.skills,
                source: this.sources,
                state: this.states,
                status: this.agency_statuses || [],
                default: [
                    {
                        id: "ab",
                        label: "ab",
                    },
                    {
                        id: "ba",
                        label: "ba",
                    },
                ],
                states: this.states || [],
            },
            delete_id: null,
        };
    },

    mounted() {
        this.current_columns = JSON.parse(JSON.stringify(this.columns));
        this.fetchData();
        window.addEventListener("resize", this.setHeightFiltersHeader);
    },

    unmounted() {
        window.removeEventListener("resize");
    },

    computed: {
        getAgencyName() {
            if (!this.delete_id) {
                return "";
            }

            const agency = this.items.length
                ? this.items.find((i) => i.id === this.delete_id)
                : [];
            if (agency) {
                if (!agency.name.sync_with_quickbooks) {
                    return `Are you sure you want to delete ${agency.name.name}?`;
                } else {
                    return `Are you sure you want to delete ${agency.name.name}? Please note that you will also need to delete <Agency name> from Quickbooks manually. You can find instructions on how to do this <a href="https://quickbooks.intuit.com/learn-support/en-us/help-article/list-management/edit-delete-restore-list-elements/L0dql1u1h_US_en_US">here</a>`;
                }
            }

            return "";
        },
    },

    methods: {
        /*changeSelect(e) {
            const id = e.id;


            if (id) {
                this.selectedAgency = id;
                this.filterData(id);
            } else {
                this.selectedAgency = null;
                this.filterItems = [];
            }
        },*/
        // setValue(e) {
        //     const name = e.target.name;
        //     const value = e.target.value;

        //     this[name] = value;

        //     this.fetchData();
        // },
        // checkboxValue(e) {
        //     if (e.target.checked) {
        //         this.selectedStatus.push(e.target.value);
        //     } else {
        //         this.selectedStatus = this.selectedStatus.filter(
        //             (i) => i != e.target.value
        //         );
        //     }
        //
        //     this.fetchData();
        // },

        deleteAgency(id) {
            this.loading = true;

            /*if (
                confirm(
                    "The agency will also be deleted from Quickbooks. Are you sure?"
                )
            ) {*/
            axios
                .post("/agencies/delete", {
                    id: id,
                })
                .then((res) => {
                    this.loading = false;
                    if (res.data.isSuccess) {
                        this.fetchData();

                        // alert(
                        //     "Don't forget to delete the agency from Quickbooks"
                        // );
                        this.delete_id = null;
                    } else if (res.data.redirect) {
                        location.href = res.data.redirect;
                    }
                })
                .catch((err) => {
                    console.error("Delete agency error", err);
                    this.loading = false;
                });
            /*} else {
                this.fetchData();
            }*/
        },

        onChangeFilterItem(value) {
            if (!this.loading) {
                this.loading = true;
                setTimeout(() => {
                    this.fetchData();
                }, 150);
            }
        },

        fetchData() {
            this.loading = true;

            axios
                .post("/agencies/getList", {
                    filters: {
                        ...this.filters,
                        search: this.searchRequest,
                    },
                })
                .then((res) => {
                    if (res.data.length) {
                        this.items = this.reformatDataByColumns(res.data);
                    } else {
                        this.items = [];
                    }
                })
                .catch((err) => {})
                .finally(() => {
                    this.setHeightFiltersHeader();
                    this.loading = false;
                })
                .finally(() => {
                    this.setHeightFiltersHeader();
                });
        },

        /*filterData(id = null) {
            this.filterItems = this.items.filter((item) => item.id === id);
        },*/
        search(value, e) {
            this.searchRequest = value;
            this.fetchData();
            // if (value.length >= 3) {
            //     this.filterItems = this.items.filter((item) =>
            //         item.name.name
            //             .toLowerCase()
            //             .includes(value.toLowerCase())
            //     );
            // }
        },

        sortData(sortBy) {
            let self = this;
            if (self.lastSort !== sortBy) self.descending = false;
            self.lastSort = sortBy;
            switch (sortBy) {
                case "id":
                    self.items = self.items.sort(
                        sortNumber("id", self.descending)
                    );
                    break;
                case "name":
                    self.items = self.items.sort(
                        sortText("name", self.descending, (a) =>
                            a.name.toUpperCase()
                        )
                    );
                    break;
                case "status":
                    self.items = self.items.sort(
                        sortText("status", self.descending)
                    );
                    break;
                case "state":
                    self.items = self.items.sort(
                        sortText("state", self.descending)
                    );
                    break;
                case "source":
                    self.items = self.items.sort(
                        sortText("source", self.descending)
                    );
                    break;
                case "active_deals":
                    self.items = self.items.sort(
                        sortNumber("active_deals", self.descending)
                    );
                    break;
                case "ytd_deals":
                    self.items = self.items.sort(
                        sortNumber("ytd_deals", self.descending)
                    );
                    break;
                case "total_deals":
                    self.items = self.items.sort(
                        sortNumber("total_deals", self.descending)
                    );
                    break;
                case "ytd_sales_amount":
                    self.items = self.items.sort(
                        sortMoney("ytd_sales_amount", self.descending)
                    );
                    break;
                case "ytd_commissions":
                    self.items = self.items.sort(
                        sortMoney("ytd_commissions", self.descending)
                    );
                    break;
                case "current_invoice":
                    self.items = self.items.sort(
                        sortMoney("current_invoice", self.descending)
                    );
                    break;
                case "total_invoice":
                    self.items = self.items.sort(
                        sortMoney("total_invoice", self.descending)
                    );
                    break;
                case "current_commissions":
                    self.items = self.items.sort(
                        sortMoney("current_commissions", self.descending)
                    );
                    break;
                case "total_commissions":
                    self.items = self.items.sort(
                        sortMoney("total_commissions", self.descending)
                    );
                    break;
                case "created_at":
                    self.items = self.items.sort(
                        sortDate("created_at", self.descending)
                    );
                    break;

                case "state":
                    self.items = self.items.sort(
                        sortText("state", self.descending)
                    );
                    break;
            }
            self.descending = !self.descending;
        },

        // MODAL COLUMNS
        reformatDataByColumns(__items = []) {
            try {
                if (__items.length >= 1) {
                    const newFormatData = [];
                    if (this.current_columns.length >= 1) {
                        __items.forEach((item) => {
                            const tempObj = {};
                            this.current_columns
                                .sort((a, b) => a.position - b.position)
                                .forEach((c) => {
                                    // if (c.status === "hidden") {
                                    //     return;
                                    // }
                                    tempObj[`${c.slug}`] = item[c.slug];

                                    if (c.slug === "name") {
                                        tempObj["name"] = {
                                            name: item["name"],
                                            link: item["agency"].url,
                                            favicon: item["favicon"],
                                            sync_with_quickbooks:
                                                item["agency"]
                                                    .sync_with_quickbooks,
                                        };
                                    }
                                });

                            newFormatData.push(tempObj);
                        });

                        return newFormatData;
                    }
                }

                return [];
            } catch (err) {
                console.error("reformatDataByColumns error", err);
            }
        },
        openColumnsModal() {
            this.showModalColumns = true;
            document.querySelector("html").style = "overflow-y: hidden";
            document.querySelector("body").style =
                "overflow-y: hidden; margin-right: 16px";
        },
        async closeModal(items = []) {
            await axios
                .post("/agencies/updateColumns", {
                    columns: items,
                })
                .then(() => {
                    this.showModalColumns = false;
                    this.current_columns.length = 0;
                    this.current_columns = JSON.parse(JSON.stringify(items));
                    document.querySelector("html").style = "";
                    document.querySelector("body").style = "";
                    this.reformatDataByColumns();
                })
                .catch((err) => {
                    console.error("Axios update columns error", err);
                });
        },
        selectColumn(col) {
            this.selected_col = col;
        },

        toggleSidebar() {
            this.is_open_sidebar = !this.is_open_sidebar;
            setTimeout(() => {
                this.setHeightFiltersHeader();
            }, 500);
        },

        clearFilter() {
            (this.searchRequest = ""),
                (this.filters = {
                    industry: null,
                    service: null,
                    name_in_quickbooks: "",
                    client_size: null,
                    international: null,
                    type: null,
                    language: null,
                    niche: null,
                    skill: null,
                    source: null,
                    min_budget: "",
                    status: null,
                    agencies_status: [],
                    budget_type: "monthly",
                    state: null,
                });
            this.fetchData();
        },

        setHeightFiltersHeader() {
            const thead = this.$refs.thead;
            const filter_header = this.$refs.filters_head;

            if (filter_header && thead) {
                filter_header.style.height = `${thead.clientHeight}px`;
            }
        },

        handleDeleteAgency(id) {
            this.delete_id = id;
        },
        handleEnterDistance(e) {
            const value = e.target.value;

            if (value) {
                if (/\d+\.?\d*/.test(value)) {
                    this.filters.distance = Number(value);

                    setTimeout(() => this.fetchData(), 500);
                }
            }
        },
        onChangeStatusCheckbox(e) {
            if (e.target.checked) {
                this.filters.agencies_status.push(e.target.value);
            } else {
                this.filters.agencies_status =
                    this.filters.agencies_status.filter(
                        (i) => i != e.target.value
                    );
            }
            this.fetchData();
        },

        onChangeStatusAll(e) {
            if (e.target.checked) {
                this.filters.agencies_status = [];
                this.options.status.forEach((filter) => {
                    const _checkbox =
                        this.$refs[`filter_status_${filter.id}`][0];
                    if (_checkbox.checked) {
                        _checkbox.checked = false;
                        _checkbox.dataset.checked = false;
                    }
                });
            }

            this.fetchData();
        },

        onChangeBudgetType(e) {
            const value = e.target.value;

            if (value) {
                this.filters.budget_type = value;
            }

            this.fetchData();
        },

        onChangeServiceIsAll(e) {
            const value = e.target.value;

            if (value) {
                this.filters.services_is_all = value === "all" ? true : false;
            }

            this.fetchData();
        },

        onChangeIndustryIsAll(e) {
            const value = e.target.value;

            if (value) {
                this.filters.industries_is_all = value === "all" ? true : false;
            }

            this.fetchData();
        },
    },
};
</script>
